import { parseUrl } from 'query-string'
import { STORAGE_ROUTER_HISTORY } from '@/common/resources/const'

const ROUTE_HISTORY_SIZE = 5

/**
 * to 객체를 받아 session storage 에 router history 를 저장한다.
 * session Storage 에 [0,1,2,3,4] 0번 (현재 url) 부터 히스토리가 순차적으로 queue 에 쌓인다.
 * @param to
 */
export const setRouteHistory = (to) => {
  const path = to?.fullPath || ''
  const routerHistoryArray = JSON.parse(sessionStorage.getItem(STORAGE_ROUTER_HISTORY)) ?? []
  const pathQueueNewestRouter = parseUrl(routerHistoryArray[0] || '')?.url
  const pathCurrentRouter = to?.path || ''

  if (pathQueueNewestRouter === pathCurrentRouter) {
    routerHistoryArray.shift()
  }

  if (routerHistoryArray.length >= ROUTE_HISTORY_SIZE) {
    routerHistoryArray.pop()
  }

  routerHistoryArray.unshift(path)
  sessionStorage.setItem(STORAGE_ROUTER_HISTORY, JSON.stringify(routerHistoryArray))
}

/**
 * 현재 쌓여있는 라우터 히스토리 큐 가져오기
 * @returns {any|*[]}
 */
export const getRouteHistory = () => JSON.parse(sessionStorage.getItem(STORAGE_ROUTER_HISTORY)) || []

/**
 * 히스토리큐를 보고 예외 라우터가 아닌 경우 해당 라우터를 리턴한다.
 * 홈, my 시청중인 컨텐츠 등
 * 예외 : 로그인 , member, 핀코드 입력
 * @returns {string}
 */

export const getPreviousRouterIfRetreatPath = () => {
  const route = getRouteHistory()
  const exceptRouteList = ['player', 'member', 'setting/pincode_check']
  const path = route[1] ?? '/'
  const isExceptRoutes = exceptRouteList.filter(route => path.match(new RegExp(`/(${route})`, `gi`))).length > 0

  if (!isExceptRoutes) return path

  return ''
}
